module.exports = __webpack_public_path__ + "static/media/pres_pgs10.4f93c924.png";